import DOMPurify from "dompurify";

function Heading(props) {
  let outerClassNames = `${props.className ?? ""} tw-text-center lg:tw-mb-5`;

  let outerProps = { ...props };
  delete outerProps.className;

  return (
    <div className={outerClassNames} {...outerProps}>
      <h2
        className="tw-text-teal tw-font-condensed tw-font-black tw-text-3xl lg:tw-text-4xl tw-uppercase tw-italic tw-leading-6 md:tw-leading-5 tw-mx-2"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(props.title),
        }}
      />
      {props.subtitle && (
        <p
          className="tw-font-black tw-font-condensed tw-text-md lg:tw-text-lg tw-uppercase tw-italic tw-leading-5 tw-mt-3 lg:tw-mt-1 tw-mx-2"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(props.subtitle),
          }}
        />
      )}
    </div>
  );
}

export default Heading;
